import { AnyObject } from 'src/types/generics';

const getObjectEntries = <T extends AnyObject, K extends keyof T>(arg: T): [K, T[K]][] => {
  return Object.entries(arg) as [K, T[K]][];
};

export { getObjectEntries };
